import packageJson from "../package.json";

/**
 * Version de l'application web, lue depuis package.json.
 * Import par defaut : webpack 5 n'expose pas les exports nommes des modules JSON.
 */
export const version: string = packageJson.version;
